"use client"
import { useTranslations } from 'next-intl';

export function LimitedStockIndicator() {
  const t = useTranslations('productDetail');
  
  return (
    <div className="relative w-full max-w-[280px] h-10 overflow-hidden rounded-lg bg-status-warning-dark backdrop-blur-lg border border-primary-dark/10">
      {/* Background track for the bar */}
      <div className="absolute inset-0 w-full h-full bg-status-warning/50"></div>

      {/* Pulsing gradient background */}
      <div className="absolute inset-0 animate-gradient-pulse bg-gradient-to-r from-status-warning/20 via-status-warning-light/30 to-status-warning/20"></div>

      {/* Diagonal stripes overlay */}
      <div className="absolute inset-0 animate-stripe-move bg-[repeating-linear-gradient(45deg,transparent,transparent_12px,rgba(255,255,255,0.05)_12px,rgba(255,255,255,0.05)_19px)] bg-[length:54px_54px] opacity-90"></div>

      {/* Text content with subtle glow */}
      <div className="relative z-10 flex items-center justify-center w-full h-full">
        <span className="text-md font-black text-static-white font-lexend-exa drop-shadow-lg drop-shadow-black uppercase animate-pulse-text">
          {t('limitedStock')}
        </span>
      </div>

      <style jsx global>{`
        @keyframes gradient-pulse {
          0%, 100% {
            opacity: 0.5;
            transform: scale(1);
          }
          50% {
            opacity: 0.8;
            transform: scale(1.05);
          }
        }
        .animate-gradient-pulse {
          animation: gradient-pulse 3s ease-in-out infinite;
        }

        @keyframes stripe-move {
          0% {
            background-position: -27px 0px;
          }
          100% {
            background-position: 0px 0px;
          }
        }
        .animate-stripe-move {
          animation: stripe-move 1.2s linear infinite;
        }

        @keyframes pulse-text {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
            text-shadow: 0 0 8px rgba(255, 255, 255, 0.1);
          }
          50% {
            opacity: 0.9;
            transform: scale(1.02);
            text-shadow: 0 0 12px rgba(255, 255, 255, 0.2);
          }
        }
        .animate-pulse-text {
          animation: pulse-text 1.5s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}
